import * as GraphqlImporter from './graphql-importer'
import commonRequestApi from '../../request'
import Response from '../../Response'
import { DocumentNode } from 'graphql'

export const SERVER_URL = '/web/gql/BasicData-default'

// 枚举
export enum LoginType {
  UNKNOWN = 'UNKNOWN',
  NORMAL = 'NORMAL',
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  IDENTITYCARD = 'IDENTITYCARD'
}

// 类

export class Page {
  pageNo?: number
  pageSize?: number
}

export class TeachUnitParamDTO {
  name?: string
  namePattern?: string
  organizationCode?: string
  organizationCodePattern?: string
  provinceId?: string
  cityId?: string
  countyId?: string
  unitStatus?: string
}

/**
 * @author linj create 2020/4/21 7:00
 */
export class LoginAccountCreateRequest {
  loginType: number
  loginInput?: string
  password?: string
}

/**
 * 登账号
@author linj create 2020/4/20 9:39
 */
export class LoginAccountUpdateRequest {
  loginType: number
  loginInput?: string
  password?: string
}

/**
 * @author linj create 2020-08-12 11:41
 */
export class UnitQueryRequest {
  /**
   * 单位名称
   */
  name?: string
  /**
   * 组织机构证编码
   */
  organizationCode?: string
}

/**
 * 管理员创建模型
@author linj create 2020/4/20 9:49
 */
export class AdministratorCreateRequest {
  /**
   * 姓名
   */
  name?: string
  /**
   * 昵称
   */
  nickName?: string
  /**
   * 头像地址
   */
  displayPhotoUrl?: string
  /**
   * 性别
   */
  sex: number
  /**
   * 手机
   */
  phoneNumber?: string
  /**
   * 邮箱
   */
  email?: string
  /**
   * 启用状态
   */
  status: number
  /**
   * 简介
   */
  remark?: string
  /**
   * 账户名
   */
  loginInput?: string
  /**
   * 密码
   */
  password?: string
  /**
   * 确认密码
   */
  confirmPassword?: string
}

/**
 * @author linj create 2020/4/21 7:13
 */
export class AdministratorParamRequest {
  /**
   * 查询单位id，默认本单位
   */
  unitId?: string
  /**
   * 用户名
   */
  loginInput?: string
  /**
   * 姓名
   */
  name?: string
  /**
   * 启用状态
   */
  status: number
  /**
   * 所属角色id
   */
  roleIds?: Array<string>
}

/**
 * 管理员修改模型
@author linj create 2020/4/20 9:48
 */
export class AdministratorUpdateRequest {
  /**
   * 管理员id
   */
  userId?: string
  /**
   * 姓名
   */
  name?: string
  /**
   * 昵称
   */
  nickName?: string
  /**
   * 头像地址
   */
  displayPhotoUrl?: string
  /**
   * 性别
   */
  sex: number
  /**
   * 手机
   */
  phoneNumber?: string
  /**
   * 邮箱
   */
  email?: string
  /**
   * 启用状态
   */
  status: number
  /**
   * 简介
   */
  remark?: string
}

/**
 * 集体缴费单位分页查询dto
@author linj create 2019/9/30 16:50
 */
export class CollectiveAdminQueryRequest {
  /**
   * 指定查询单位id
   */
  unitId?: string
  /**
   * 管理员姓名
   */
  name?: string
}

/**
 * @author linj create 2020-08-11 16:42
 */
export class CollectiveAdministratorCreateRequest {
  /**
   * 姓名
   */
  name?: string
  /**
   * 昵称
   */
  nickName?: string
  /**
   * 唯一性类型
@see UniqueTypeConst
   */
  uniqueType: number
  /**
   * 唯一性值
   */
  uniqueData?: string
  /**
   * 头像地址
   */
  displayPhotoUrl?: string
  /**
   * 性别
@see SexConst
   */
  sex: number
  /**
   * 出生年月
   */
  bornDay?: string
  /**
   * 手机号码
   */
  phoneNumber?: string
  /**
   * 邮政编码
   */
  postCode?: string
  /**
   * 所属地区编码
   */
  areaPath?: string
  /**
   * 联系地址
   */
  address?: string
  /**
   * 注册方式
@see RegisterTypeConst
   */
  registerType: number
  /**
   * 注册来源
@see SourceTypeConst
   */
  sourceType: number
  /**
   * 注册来源单位id
   */
  registerUnitId?: string
  /**
   * 集体缴费单位id
   */
  collectiveUnitId?: string
  /**
   * 单位地区
   */
  provinceId?: string
  /**
   * 单位地区 市
   */
  cityId?: string
  /**
   * 单位地区 区县
   */
  countyId?: string
  /**
   * 单位名称
   */
  unitName?: string
  /**
   * 组织机构代码
   */
  organizationCode?: string
  /**
   * 登陆账号集合
   */
  loginAccounts?: Array<LoginAccountCreateRequest>
}

/**
 * @author linj create 2020-08-14 11:14
 */
export class CollectiveAdministratorUpdateRequest {
  /**
   * 用户id
   */
  userId?: string
  /**
   * 姓名
   */
  name?: string
  /**
   * 昵称
   */
  nickName?: string
  /**
   * 手机号
   */
  phoneNumber?: string
}

/**
 * @author linj create 2020-08-11 19:44
 */
export class CollectiveUnitQueryRequest {
  /**
   * 指定查询单位id
   */
  unitId?: string
  /**
   * 指定查询单位id集合，{@link #unitId} 优先，若已指定，此搜索项无效
   */
  unitIds?: Array<string>
  /**
   * 集体缴费单位所属地区路径
   */
  regionPath?: string
  /**
   * 单位名称
   */
  unitName?: string
  /**
   * 单位状态 | 1：正常;2:停用
   */
  unitStatus?: string
}

/**
 * @author linj create 2020-08-26 20:49
 */
export class CollectiveUnitUpdateRequest {
  /**
   * 单位id
   */
  unitId?: string
  /**
   * 单位名称
   */
  name?: string
  /**
   * 组织机构代码
   */
  organizationCode?: string
  /**
   * 单位地区
   */
  provinceId?: string
  /**
   * 单位地区 市
   */
  cityId?: string
  /**
   * 单位地区 区县
   */
  countyId?: string
}

/**
 * @author linj create 2020-06-29 11:47
 */
export class DingTalkDepartmentQueryRequest {
  /**
   * 部门名称
   */
  name?: string
}

/**
 * 资源（内容）供应商 管理员 与 单位同步 创建dto
@author linj create 2020/6/5 19:32
 */
export class ResourceVendorsAdminCreateAlongWithUnitRequest {
  /**
   * 姓名
   */
  name?: string
  /**
   * 昵称
   */
  nickName?: string
  /**
   * 唯一性类型
@see UniqueTypeConst
   */
  uniqueType: number
  /**
   * 唯一性值
   */
  uniqueData?: string
  /**
   * 用户手机号码
   */
  phoneNumber?: string
  /**
   * 登陆账号集合
   */
  loginAccounts?: Array<LoginAccountCreateRequest>
}

/**
 * 资源（内容）供应商 管理员 创建dto
@author linj create 2020/6/5 19:29
 */
export class ResourceVendorsAdminCreateRequest {
  /**
   * 单位id
   */
  unitId?: string
  /**
   * 姓名
   */
  name?: string
  /**
   * 昵称
   */
  nickName?: string
  /**
   * 唯一性类型
@see UniqueTypeConst
   */
  uniqueType: number
  /**
   * 唯一性值
   */
  uniqueData?: string
  /**
   * 登陆账号集合
   */
  loginAccounts?: Array<LoginAccountCreateRequest>
}

/**
 * 资源（内容）供应商 管理员 修改dto
@author linj create 2020/6/5 19:29
 */
export class ResourceVendorsAdminUpdateRequest {
  /**
   * 用户id
   */
  userId?: string
  /**
   * 单位id
   */
  unitId?: string
  /**
   * 姓名
   */
  name?: string
  /**
   * 昵称
   */
  nickName?: string
  /**
   * 唯一性类型
@see UniqueTypeConst
   */
  uniqueType: number
  /**
   * 唯一性值
   */
  uniqueData?: string
}

/**
 * 资源供应商单位创建请求
@author linj create 2020/6/5 21:07
 */
export class ResourceVendorsUnitAndAdminCreateRequest {
  /**
   * 单位名称
   */
  name?: string
  /**
   * 资源提供商 图片路径
   */
  iconPath?: string
  /**
   * 组织机构代码
   */
  organizationCode?: string
  /**
   * 单位地区
   */
  provinceId?: string
  /**
   * 单位地区 市
   */
  cityId?: string
  /**
   * 单位地区 区县
   */
  countyId?: string
  /**
   * 联系人
   */
  linkPerson?: string
  /**
   * 联系电话
   */
  phone?: string
  /**
   * 同步创建的管理员信息
   */
  admin?: ResourceVendorsAdminCreateAlongWithUnitRequest
}

/**
 * 资源供应商单位创建请求
@author linj create 2020/6/5 21:07
 */
export class ResourceVendorsUnitUpdateRequest {
  /**
   * 单位id
   */
  unitId?: string
  /**
   * 单位名称
   */
  name?: string
  /**
   * 资源提供商 图片路径
   */
  iconPath?: string
  /**
   * 组织机构代码
   */
  organizationCode?: string
  /**
   * 单位地区
   */
  provinceId?: string
  /**
   * 单位地区 市
   */
  cityId?: string
  /**
   * 单位地区 区县
   */
  countyId?: string
  /**
   * 联系人
   */
  linkPerson?: string
  /**
   * 联系电话
   */
  phone?: string
}

/**
 * @author linj create 2020/4/21 6:59
 */
export class StudentCreateRequest {
  /**
   * 姓名
   */
  name?: string
  /**
   * 昵称
   */
  nickName?: string
  /**
   * 唯一性类型
@see UniqueTypeConst
   */
  uniqueType: number
  /**
   * 唯一性值
   */
  uniqueData?: string
  /**
   * 头像地址
   */
  displayPhotoUrl?: string
  /**
   * 性别
@see SexConst
   */
  sex: number
  /**
   * 出生年月
   */
  bornDay?: string
  /**
   * 手机号码
   */
  phoneNumber?: string
  /**
   * 邮政编码
   */
  postCode?: string
  /**
   * 所属地区编码
   */
  areaPath?: string
  /**
   * 联系地址
   */
  address?: string
  /**
   * 注册方式
@see RegisterTypeConst
   */
  registerType: number
  /**
   * 注册来源
@see SourceTypeConst
   */
  sourceType: number
  /**
   * 注册来源单位id
   */
  registerUnitId?: string
  /**
   * 登陆账号集合
   */
  loginAccounts?: Array<LoginAccountCreateRequest>
  /**
   * 最高学历 | 推荐使用：参考国标【GB/T 4658 2006】, 值为【学历】字典ID；不完全参考国标，值为学历名称
   */
  highestEducation?: string
  /**
   * 工作单位id
   */
  workUnitIds?: Array<string>
  /**
   * 工作单位名称(只存储名称，用于给没有实体工作单位的项目使用)
   */
  workUnitName?: string
  /**
   * 工作单位所在地区路径(用于给没有实体工作单位的项目使用)
   */
  workUnitAreaPath?: string
}

/**
 * @author linj create 2020/4/23 15:20
 */
export class StudentCreateWithPhoneCaptchaAndTokenRequest {
  /**
   * token
   */
  token?: string
  /**
   * 姓名
   */
  name?: string
  /**
   * 昵称
   */
  nickName?: string
  /**
   * 唯一性类型
@see UniqueTypeConst
   */
  uniqueType: number
  /**
   * 唯一性值
   */
  uniqueData?: string
  /**
   * 头像地址
   */
  displayPhotoUrl?: string
  /**
   * 性别
@see SexConst
   */
  sex: number
  /**
   * 出生年月
   */
  bornDay?: string
  /**
   * 邮政编码
   */
  postCode?: string
  /**
   * 所属地区编码
   */
  areaPath?: string
  /**
   * 联系地址
   */
  address?: string
  /**
   * 注册方式
@see RegisterTypeConst
   */
  registerType: number
  /**
   * 注册来源
@see SourceTypeConst
   */
  sourceType: number
  /**
   * 注册来源单位id
   */
  registerUnitId?: string
  /**
   * 默认密码
   */
  password?: string
  /**
   * 工作单位id
   */
  workUnitIds?: Array<string>
  /**
   * 工作单位名称(只存储名称，用于给没有实体工作单位的项目使用)
   */
  workUnitName?: string
  /**
   * 工作单位所在地区路径(用于给没有实体工作单位的项目使用)
   */
  workUnitAreaPath?: string
}

/**
 * @author linj create 2020/4/21 7:03
 */
export class StudentCreateWithPhoneCaptchaRequest {
  /**
   * 姓名
   */
  name?: string
  /**
   * 昵称
   */
  nickName?: string
  /**
   * 唯一性类型
@see UniqueTypeConst
   */
  uniqueType: number
  /**
   * 唯一性值
   */
  uniqueData?: string
  /**
   * 头像地址
   */
  displayPhotoUrl?: string
  /**
   * 性别
@see SexConst
   */
  sex: number
  /**
   * 出生年月
   */
  bornDay?: string
  /**
   * 邮政编码
   */
  postCode?: string
  /**
   * 所属地区编码
   */
  areaPath?: string
  /**
   * 联系地址
   */
  address?: string
  /**
   * 注册方式
@see RegisterTypeConst
   */
  registerType: number
  /**
   * 注册来源
@see SourceTypeConst
   */
  sourceType: number
  /**
   * 注册来源单位id
   */
  registerUnitId?: string
  /**
   * 默认密码
   */
  password?: string
  /**
   * 工作单位id
   */
  workUnitIds?: Array<string>
  /**
   * 工作单位名称(只存储名称，用于给没有实体工作单位的项目使用)
   */
  workUnitName?: string
  /**
   * 工作单位所在地区路径(用于给没有实体工作单位的项目使用)
   */
  workUnitAreaPath?: string
}

/**
 * @author linj create 2020/4/21 7:04
 */
export class StudentUpdateRequest {
  /**
   * 学员ID
   */
  userId?: string
  /**
   * 姓名
   */
  name?: string
  /**
   * 昵称
   */
  nickName?: string
  /**
   * 唯一性类型
@see UniqueTypeConst
   */
  uniqueType: number
  /**
   * 唯一性值
   */
  uniqueData?: string
  /**
   * 头像地址
   */
  displayPhotoUrl?: string
  /**
   * 性别
@see SexConst
   */
  sex: number
  /**
   * 出生年月
   */
  bornDay?: string
  /**
   * 手机号码
   */
  phoneNumber?: string
  /**
   * 邮政编码
   */
  postCode?: string
  /**
   * 所属地区编码
   */
  areaPath?: string
  /**
   * 联系地址
   */
  address?: string
  /**
   * 注册方式
@see RegisterTypeConst
   */
  registerType: number
  /**
   * 注册来源
@see SourceTypeConst
   */
  sourceType: number
  /**
   * 注册来源单位id
   */
  registerUnitId?: string
  /**
   * 登陆账号集合
   */
  loginAccounts?: Array<LoginAccountUpdateRequest>
  /**
   * 最高学历 | 推荐使用：参考国标【GB/T 4658 2006】, 值为【学历】字典ID；不完全参考国标，值为学历名称
   */
  highestEducation?: string
  /**
   * 工作单位id
   */
  workUnitIds?: Array<string>
  /**
   * 工作单位名称(只存储名称，用于给没有实体工作单位的项目使用)
   */
  workUnitName?: string
  /**
   * 工作单位所在地区路径(用于给没有实体工作单位的项目使用)
   */
  workUnitAreaPath?: string
}

/**
 * @author linj create 2020/4/21 7:06
 */
export class TeachAdministratorCreateRequest {
  /**
   * 单位id
   */
  unitId?: string
  /**
   * 姓名
   */
  name?: string
  /**
   * 昵称
   */
  nickName?: string
  /**
   * 唯一性类型
@see UniqueTypeConst
   */
  uniqueType: number
  /**
   * 唯一性值
   */
  uniqueData?: string
  /**
   * 登陆账号集合
   */
  loginAccounts?: Array<LoginAccountCreateRequest>
}

/**
 * @author linj create 2020/4/21 7:12
 */
export class TeachAdministratorParamRequest {
  /**
   * 单位id
   */
  unitId?: string
  /**
   * 姓名
   */
  name?: string
  /**
   * 用户状态. 不使用该条件时传递空数组.
1: 正常; 2: 停用(冻结); 3: 注销;
   */
  status: Array<number>
}

/**
 * @author linj create 2020/4/21 7:09
 */
export class TeachAdministratorUpdateRequest {
  /**
   * 用户id
   */
  userId?: string
  /**
   * 单位id
   */
  unitId?: string
  /**
   * 姓名
   */
  name?: string
  /**
   * 昵称
   */
  nickName?: string
  /**
   * 唯一性类型
@see UniqueTypeConst
   */
  uniqueType: number
  /**
   * 唯一性值
   */
  uniqueData?: string
}

/**
 * @author linj create 2020/4/21 7:14
 */
export class TeachUnitCreateRequest {
  /**
   * 单位名称
   */
  name?: string
  /**
   * 组织机构代码
   */
  organizationCode?: string
  /**
   * 单位地区
   */
  provinceId?: string
  /**
   * 单位地区 市
   */
  cityId?: string
  /**
   * 单位地区 区县
   */
  countyId?: string
  /**
   * 门户名称
   */
  portalName?: string
  /**
   * 域名
   */
  unitDomain?: string
  /**
   * 姓名
   */
  adminName?: string
  /**
   * 唯一性类型
@see UniqueTypeConst
   */
  uniqueType: number
  /**
   * 唯一性值
   */
  uniqueData?: string
  /**
   * 登陆账号集合
   */
  loginAccounts?: Array<LoginAccountCreateRequest>
  /**
   * logo地址
   */
  logoUrl?: string
  /**
   * 轮播图列表
   */
  bannerUrls?: Array<string>
  /**
   * 门户页脚描述
   */
  portalFooterDescribe?: string
  /**
   * 在线客服信息
   */
  onlineCustomerInfo?: string
  /**
   * 客服电话
   */
  customerPhone?: string
}

/**
 * @author linj create 2020/4/21 7:17
 */
export class TeachUnitUpdateRequest {
  /**
   * 单位id
   */
  unitId?: string
  /**
   * 单位名称
   */
  name?: string
  /**
   * 组织机构代码
   */
  organizationCode?: string
  /**
   * 单位地区
   */
  provinceId?: string
  /**
   * 单位地区 市
   */
  cityId?: string
  /**
   * 单位地区 区县
   */
  countyId?: string
  /**
   * 门户名称
   */
  portalName?: string
  /**
   * 域名
   */
  unitDomain?: string
  /**
   * logo地址
   */
  logoUrl?: string
  /**
   * 轮播图列表
   */
  bannerUrls?: Array<string>
  /**
   * 门户页脚描述
   */
  portalFooterDescribe?: string
  /**
   * 在线客服信息
   */
  onlineCustomerInfo?: string
  /**
   * 客服电话
   */
  customerPhone?: string
}

export class LoginAccountDTO {
  loginType: number
  loginInput: string
  password: string
}

export class Region {
  regionPath: string
  provinceId: string
  provinceName: string
  cityId: string
  cityName: string
  countyId: string
  countyName: string
}

/**
 * @author linj create 2020/4/21 6:58
 */
export class BaseRegionResponse {
  /**
   * 地区 id
   */
  id: string
  /**
   * 地区 名称
   */
  name: string
  /**
   * 上级区域ID|顶级空，为空默认为-1
   */
  parentId: string
  /**
   * 区域路径
   */
  regionPath: string
  /**
   * 排序
   */
  sort: number
  /**
   * 版本号
   */
  version: string
  /**
   * 是否可用
   */
  available: boolean
}

/**
 * @author linj create 2020-08-31 17:37
 */
export class CommonUserInfoResponse {
  /**
   * 用户ID
   */
  userId: string
  /**
   * 用户所属平台ID
   */
  platformId: string
  /**
   * 用户所属平台版本ID
   */
  platformVersionId: string
  /**
   * 用户所属项目ID
   */
  projectId: string
  /**
   * 用户所属子项目ID
   */
  subProjectId: string
  /**
   * 用户所属单位ID
   */
  unitId: string
  /**
   * 用户所属组织机构ID
   */
  organizationId: string
  /**
   * 用户域类型
@see UserdataNorthConstant#USER_REGION_TYPE_CUSTOMER
@see UserdataNorthConstant#USER_REGION_TYPE_OPERATOR
@see UserdataNorthConstant#USER_REGION_TYPE_MAINTAINER
   */
  userType: number
  /**
   * 用户昵称
   */
  nickname: string
  /**
   * 用户头像访问地址
   */
  displayPhotoUrl: string
  /**
   * 用户的状态
@see UserdataNorthConstant#USER_STATUS_NORMAL
@see UserdataNorthConstant#USER_STATUS_FROZEN
@see UserdataNorthConstant#USER_STATUS_DELETE
   */
  status: number
  /**
   * 是否已激活
   */
  activated: boolean
  /**
   * 用户信息是否完善
   */
  perfect: boolean
  /**
   * 是否是测试
   */
  test: boolean
  /**
   * 用户唯一性标识类型
   */
  uniqueType: number
  /**
   * 用户唯一性标识值
   */
  uniqueData: string
}

/**
 * @author linj create 2020/4/21 6:52
 */
export class LoginAccountResponse {
  loginType: number
  loginInput: string
  password: string
}

/**
 * @author linj create 2020/4/21 6:53
 */
export class OperatorResponse {
  /**
   * 用户id
   */
  userId: string
  /**
   * 姓名
   */
  name: string
  /**
   * 呢称
   */
  nickName: string
  /**
   * 唯一标识
   */
  uniqueData: string
}

/**
 * @author linj create 2020/4/21 6:51
 */
export class RegionResponse {
  /**
   * 地区路径
   */
  regionPath: string
  /**
   * 省份id
   */
  provinceId: string
  /**
   * 省份名称
   */
  provinceName: string
  /**
   * 城市id
   */
  cityId: string
  /**
   * 城市名称
   */
  cityName: string
  /**
   * 区、县id
   */
  countyId: string
  /**
   * 区、县名称
   */
  countyName: string
}

/**
 * 角色响应
@author linj create 2020/4/20 9:56
 */
export class RoleResponse {
  /**
   * 角色id
   */
  id: string
  /**
   * 角色名称
   */
  roleName: string
}

/**
 * @author linj create 2020-08-12 11:44
 */
export class ThirdIndustryCommerceInfoResponse {
  /**
   * 企业编号
   */
  id: string
  /**
   * 企业名称
@return
   */
  name: string
  /**
   * 社会统一信用代码
   */
  creditCode: string
  /**
   * 注册资金
   */
  registerCapital: string
  /**
   * 企业开始经营的时间
   */
  manageStartTime: string
  /**
   * 企业的法人名称
   */
  legalPersonName: string
}

/**
 * @author linj create 2020-08-12 11:43
 */
export class UnitItemResponse {
  /**
   * 主键单位ID
   */
  unitId: string
  /**
   * 平台ID
   */
  platformId: string
  /**
   * 平台版本ID
   */
  platformVersionId: string
  /**
   * 项目ID
   */
  projectId: string
  /**
   * 子项目
   */
  subProjectId: string
  /**
   * 单位名称
   */
  name: string
  /**
   * 组织机构证
   */
  organizationCode: string
  /**
   * 单位地区
   */
  provinceId: string
  /**
   * 单位地区 市
   */
  cityId: string
  /**
   * 单位地区 区县
   */
  countyId: string
  /**
   * 单位状态 | 1：正常;2:停用  默认正常
   */
  status: string
}

/**
 * @author linj create 2020/4/21 6:50
 */
export class UnitResponse {
  /**
   * 单位id
   */
  unitId: string
  /**
   * 平台ID
   */
  platformId: string
  /**
   * 平台版本ID
   */
  platformVersionId: string
  /**
   * 项目ID
   */
  projectId: string
  /**
   * 子项目ID
   */
  subProjectId: string
  /**
   * 组织机构ID
   */
  organizationId: string
  /**
   * 单位名称
   */
  name: string
  /**
   * 单位地区
   */
  region: RegionResponse
  /**
   * 状态
   */
  status: string
  /**
   * 单位性质
   */
  unitAttributed: number
  /**
   * 组织机构证编码
   */
  organizationCode: string
  /**
   * 联系人
   */
  linkPerson: string
}

/**
 * @author linj create 2020/4/21 6:55
 */
export class AdministratorPageResponse {
  /**
   * 用户ID
   */
  userId: string
  /**
   * 账号
   */
  loginInputs: Array<string>
  /**
   * 姓名
   */
  name: string
  /**
   * 单位id
   */
  unitId: string
  /**
   * 单位名称
   */
  unitName: string
  /**
   * 手机
   */
  phoneNumber: string
  /**
   * 邮箱
   */
  email: string
  /**
   * 启用状态
   */
  status: number
  /**
   * 性别.
男:1,女:2,中性:3,未知:4
   */
  sex: number
  /**
   * 地区id
   */
  areaId: string
  /**
   * 地区名
   */
  areaName: string
  /**
   * 头像地址
   */
  displayPhotoUrl: string
  /**
   * 简述
   */
  simpleDescription: string
  /**
   * 简介
   */
  remark: string
  /**
   * 角色名称集合
   */
  roleNameList: Array<string>
  /**
   * 用户创建人ID
   */
  creatorId: string
  /**
   * 用户创建日期
   */
  createTime: string
}

/**
 * 管理员信息
@author linj create 2020/4/20 9:52
 */
export class AdministratorResponse {
  /**
   * 用户id
   */
  userId: string
  /**
   * 管理员姓名
   */
  name: string
  /**
   * 管理员昵称
   */
  nickName: string
  /**
   * 单位id
   */
  unitId: string
  /**
   * 单位名称
   */
  unitName: string
  /**
   * 手机号码
   */
  phoneNumber: string
  /**
   * 电子邮箱
   */
  email: string
  /**
   * 状态
   */
  status: number
  /**
   * 性别
   */
  sex: number
  /**
   * 头像路径
   */
  displayPhotoUrl: string
  /**
   * 备注信息
   */
  remark: string
  /**
   * 创建人信息
   */
  creator: OperatorResponse
  /**
   * 创建时间
   */
  createTime: string
  /**
   * 登录账号信息
   */
  loginAccounts: Array<LoginAccountResponse>
  /**
   * 角色信息
   */
  roles: Array<RoleResponse>
  /**
   * 单位信息
   */
  unit: UnitResponse
}

/**
 * @author linj create 2020-08-26 20:56
 */
export class CollectiveAdminItemResponse {
  /**
   * 集体缴费管理员ID
   */
  userId: string
  /**
   * 集体缴费单位id
   */
  collectiveUnitId: string
  /**
   * 姓名
   */
  name: string
  /**
   * 昵称
   */
  nickName: string
  /**
   * 唯一性类型
@see UniqueTypeConst
   */
  uniqueType: number
  /**
   * 唯一性值
   */
  uniqueData: string
  /**
   * 头像地址
   */
  displayPhotoUrl: string
  /**
   * 性别
@see SexConst
   */
  sex: number
  /**
   * 出生年月
   */
  bornDay: string
  /**
   * 手机号码
   */
  phoneNumber: string
  /**
   * 邮政编码
   */
  postCode: string
  /**
   * 所属地区编码
   */
  areaPath: string
  /**
   * 联系地址
   */
  address: string
}

/**
 * @author linj create 2020-08-11 16:34
 */
export class CollectiveAdministratorResponse {
  /**
   * 集体缴费管理员ID
   */
  userId: string
  /**
   * 集体缴费单位id
   */
  collectiveUnitId: string
  /**
   * 平台ID
   */
  platformId: string
  /**
   * 平台版本ID
   */
  platformVersionId: string
  /**
   * 项目ID
   */
  projectId: string
  /**
   * 子项目ID
   */
  subProjectId: string
  /**
   * 单位ID
   */
  unitId: string
  /**
   * 组织机构ID
   */
  organizationId: string
  /**
   * 姓名
   */
  name: string
  /**
   * 昵称
   */
  nickName: string
  /**
   * 唯一性类型
@see UniqueTypeConst
   */
  uniqueType: number
  /**
   * 唯一性值
   */
  uniqueData: string
  /**
   * 头像地址
   */
  displayPhotoUrl: string
  /**
   * 性别
@see SexConst
   */
  sex: number
  /**
   * 出生年月
   */
  bornDay: string
  /**
   * 手机号码
   */
  phoneNumber: string
  /**
   * 邮政编码
   */
  postCode: string
  /**
   * 所属地区编码
   */
  areaPath: string
  /**
   * 联系地址
   */
  address: string
  /**
   * 注册方式
@see RegisterTypeConst
   */
  registerType: number
  /**
   * 注册来源
@see SourceTypeConst
   */
  sourceType: number
  /**
   * 登陆账号集合
   */
  loginAccounts: Array<LoginAccountResponse>
  /**
   * 创建日期
   */
  createTime: string
}

/**
 * @author linj create 2020-08-11 19:41
 */
export class CollectiveUnitItemResponse {
  /**
   * 集体缴费单位ID
   */
  unitId: string
  /**
   * 单位名称
   */
  name: string
  /**
   * 地区路径
   */
  region: Region
  /**
   * 集体缴费单位管理员
   */
  manager: CollectiveUnitManagerResponse
  /**
   * 组织机构证
   */
  organizationCode: string
  /**
   * 单位状态 | 1：正常;2:停用  默认正常
   */
  status: number
  /**
   * 创建时间
   */
  createTime: string
}

/**
 * @author linj create 2020-08-11 19:42
 */
export class CollectiveUnitManagerResponse {
  /**
   * 管理员id
   */
  managerId: string
  /**
   * 管理员姓名
   */
  name: string
  /**
   * 管理员账号
   */
  loginAccount: string
}

/**
 * @author linj create 2020-08-26 20:51
 */
export class CollectiveUnitResponse {
  /**
   * 集体缴费单位ID
   */
  unitId: string
  /**
   * 单位名称
   */
  name: string
  /**
   * 地区路径
   */
  region: Region
  /**
   * 组织机构证
   */
  organizationCode: string
  /**
   * 单位状态 | 1：正常;2:停用  默认正常
   */
  status: string
  /**
   * 创建时间
   */
  createTime: string
}

/**
 * 钉钉部门响应
@author linj create 2020-06-29 10:32
 */
export class DingTalkDepartmentResponse {
  /**
   * 部门id
   */
  deptId: string
  /**
   * 钉钉部门对应本地单位id
   */
  unitId: string
  /**
   * 部门名称
   */
  name: string
  /**
   * 在父部门中的次序值
   */
  sort: number
  /**
   * 父部门id，根部门为1
   */
  parentId: string
  /**
   * 部门标识字段，开发者可用该字段来唯一标识一个部门，并与钉钉外部通讯录里的部门做映射
   */
  sourceIdentifier: string
}

/**
 * 资源（内容）供应商 管理员 创建dto
@author linj create 2020/6/5 19:29
 */
export class ResourceVendorsAdminResponse {
  /**
   * 用户id
   */
  userId: string
  /**
   * 单位id
   */
  unitId: string
  /**
   * 姓名
   */
  name: string
  /**
   * 昵称
   */
  nickName: string
  /**
   * 唯一性类型
@see UniqueTypeConst
   */
  uniqueType: number
  /**
   * 唯一性值
   */
  uniqueData: string
  /**
   * 用户手机号码
   */
  phoneNumber: string
  /**
   * 登陆账号集合
   */
  loginAccounts: Array<LoginAccountDTO>
  /**
   * 用户状态,正常: 1; 冻结: 2; 注销: 3;
   */
  status: number
  /**
   * 创建时间
   */
  createTime: string
}

/**
 * @author linj create 2020/6/5 19:46
 */
export class ResourceVendorsCreateWithAdminResultResponse {
  /**
   * 资源供应商单位
   */
  resourceVendors: ResourceVendorsUnitResponse
  /**
   * 资源供应商管理员
   */
  resourceVendorsAdmin: ResourceVendorsAdminResponse
}

/**
 * 资源（内容）供应商 创建dto
@author linj create 2020/6/5 16:36
 */
export class ResourceVendorsUnitResponse {
  /**
   * 单位id
   */
  unitId: string
  /**
   * 单位名称
   */
  name: string
  /**
   * 资源提供商 图片路径
   */
  iconPath: string
  /**
   * 组织机构代码
   */
  organizationCode: string
  /**
   * 单位地区
   */
  provinceId: string
  /**
   * 单位地区 市
   */
  cityId: string
  /**
   * 单位地区 区县
   */
  countyId: string
  /**
   * 联系人
   */
  linkPerson: string
  /**
   * 联系电话
   */
  phone: string
  /**
   * 创建时间
   */
  createTime: string
  /**
   * 状态&quot;1&quot;&#x3D;正常 &quot;2&quot;&#x3D;停用
   */
  status: string
}

/**
 * @author linj create 2020/4/21 7:02
 */
export class StudentResponse {
  /**
   * 学员ID
   */
  userId: string
  /**
   * 姓名
   */
  name: string
  /**
   * 昵称
   */
  nickName: string
  /**
   * 唯一性类型
@see UniqueTypeConst
   */
  uniqueType: number
  /**
   * 唯一性值
   */
  uniqueData: string
  /**
   * 头像地址
   */
  displayPhotoUrl: string
  /**
   * 性别
@see SexConst
   */
  sex: number
  /**
   * 出生年月
   */
  bornDay: string
  /**
   * 手机号码
   */
  phoneNumber: string
  /**
   * 邮政编码
   */
  postCode: string
  /**
   * 所属地区编码
   */
  areaPath: string
  /**
   * 联系地址
   */
  address: string
  /**
   * 用户创建日期
   */
  createDate: string
  /**
   * 注册方式
@see RegisterTypeConst
   */
  registerType: number
  /**
   * 注册来源
@see SourceTypeConst
   */
  sourceType: number
  /**
   * 注册来源单位id
   */
  registerUnitId: string
  /**
   * 登陆账号集合
   */
  loginAccounts: Array<LoginAccountResponse>
  /**
   * 所属单位ID
   */
  unitId: string
  /**
   * 最高学历 | 推荐使用：参考国标【GB/T 4658 2006】, 值为【学历】字典ID；不完全参考国标，值为学历名称
   */
  highestEducation: string
  /**
   * 学员所属工作单位（实体单位）
   */
  workUnitIds: Array<string>
  /**
   * 工作单位名称(只存储名称，用于给没有实体工作单位的项目使用)
   */
  workUnitName: string
  /**
   * 工作单位所在地区路径(用于给没有实体工作单位的项目使用)
   */
  workUnitAreaPath: string
}

/**
 * @author linj create 2020/4/21 7:10
 */
export class TeachAdministratorItemResponse {
  /**
   * 用户id
   */
  userId: string
  /**
   * 单位id
   */
  unitId: string
  /**
   * 姓名
   */
  name: string
  /**
   * 昵称
   */
  nickName: string
  /**
   * 唯一性类型
@see UniqueTypeConst
   */
  uniqueType: number
  /**
   * 唯一性值
   */
  uniqueData: string
  /**
   * 状态
   */
  status: number
  /**
   * 登陆账号集合
   */
  loginAccounts: Array<LoginAccountResponse>
}

/**
 * @author linj create 2020/4/21 7:08
 */
export class TeachAdministratorResponse {
  /**
   * 用户id
   */
  userId: string
  /**
   * 单位id
   */
  unitId: string
  /**
   * 姓名
   */
  name: string
  /**
   * 昵称
   */
  nickName: string
  /**
   * 唯一性类型
@see UniqueTypeConst
   */
  uniqueType: number
  /**
   * 唯一性值
   */
  uniqueData: string
  /**
   * 用户状态
<p>正常: 1; 冻结: 2; 注销: 3;
@see UserMaterialConstant#USER_STATUS_NORMAL
@see UserMaterialConstant#USER_STATUS_FROZEN
@see UserMaterialConstant#USER_STATUS_LOGOUT
   */
  status: number
  /**
   * 登陆账号集合
   */
  loginAccounts: Array<LoginAccountResponse>
}

/**
 * @author linj create 2020/4/21 7:18
 */
export class TeachUnitItemResponse {
  /**
   * 主键单位ID
   */
  id: string
  /**
   * 平台ID
   */
  platformId: string
  /**
   * 平台版本ID
   */
  platformVersionId: string
  /**
   * 项目ID
   */
  projectId: string
  /**
   * 子项目
   */
  subProjectId: string
  /**
   * 单位名称
   */
  name: string
  /**
   * 组织机构证
   */
  organizationCode: string
  /**
   * 单位地区
   */
  provinceId: string
  /**
   * 单位地区 市
   */
  cityId: string
  /**
   * 单位地区 区县
   */
  countyId: string
  /**
   * 单位状态 | 1：正常;2:停用  默认正常
   */
  status: string
  /**
   * 施教机构管理员
   */
  teachManager: TeachAdministratorResponse
  /**
   * 门户名称
   */
  portalName: string
  /**
   * logo地址
   */
  logoUrl: string
  /**
   * 轮播图列表
   */
  bannerUrls: Array<string>
  /**
   * 门户页脚描述
   */
  portalFooterDescribe: string
  /**
   * 在线客服信息
   */
  onlineCustomerInfo: string
  /**
   * 客服电话
   */
  customerPhone: string
  /**
   * 域名
   */
  defaultUnitDomain: UnitDomainResponse
}

/**
 * @author linj create 2020/4/21 7:15
 */
export class TeachUnitResponse {
  /**
   * 单位id
   */
  unitId: string
  /**
   * 单位名称
   */
  name: string
  /**
   * 组织机构代码
   */
  organizationCode: string
  /**
   * 单位地区
   */
  provinceId: string
  /**
   * 单位地区 市
   */
  cityId: string
  /**
   * 单位地区 区县
   */
  countyId: string
  /**
   * 状态
   */
  status: string
  /**
   * 门户名称
   */
  portalName: string
  /**
   * 域名
   */
  defaultUnitDomain: UnitDomainResponse
  /**
   * logo地址
   */
  logoUrl: string
  /**
   * 轮播图列表
   */
  bannerUrls: Array<string>
  /**
   * 门户页脚描述
   */
  portalFooterDescribe: string
  /**
   * 在线客服信息
   */
  onlineCustomerInfo: string
  /**
   * 客服电话
   */
  customerPhone: string
}

/**
 * @author linj create 2020/4/21 7:16
 */
export class UnitDomainResponse {
  /**
   * 主键 系统域名ID
   */
  id: string
  /**
   * 项目ID
   */
  projectId: string
  /**
   * 子项目ID
   */
  subProjectId: string
  /**
   * 单位id
   */
  unitId: string
  /**
   * 平台ID
   */
  platformId: string
  /**
   * 平台版本ID
   */
  platformVersionId: string
  /**
   * 系统域名
   */
  domain: string
  /**
   * 域名状态|1：开启 2：暂停 3：过期  4：维护
   */
  domainState: string
}

export class TeachAdministratorItemResponsePage {
  pageSize: number
  pageNo: number
  totalPageSize: number
  totalSize: number
  currentPageData: Array<TeachAdministratorItemResponse>
}

export class TeachUnitItemResponsePage {
  pageSize: number
  pageNo: number
  totalPageSize: number
  totalSize: number
  currentPageData: Array<TeachUnitItemResponse>
}

export class AdministratorPageResponsePage {
  pageSize: number
  pageNo: number
  totalPageSize: number
  totalSize: number
  currentPageData: Array<AdministratorPageResponse>
}

export class CollectiveAdminItemResponsePage {
  pageSize: number
  pageNo: number
  totalPageSize: number
  totalSize: number
  currentPageData: Array<CollectiveAdminItemResponse>
}

export class CollectiveUnitItemResponsePage {
  pageSize: number
  pageNo: number
  totalPageSize: number
  totalSize: number
  currentPageData: Array<CollectiveUnitItemResponse>
}

export class DingTalkDepartmentResponsePage {
  pageSize: number
  pageNo: number
  totalPageSize: number
  totalSize: number
  currentPageData: Array<DingTalkDepartmentResponse>
}

export class UnitItemResponsePage {
  pageSize: number
  pageNo: number
  totalPageSize: number
  totalSize: number
  currentPageData: Array<UnitItemResponse>
}

class DataGateway {
  async _commonQuery<T>(query: DocumentNode, params?: unknown, operation?: string): Promise<Response<T>> {
    return commonRequestApi<T>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 获取当前管理员详情
   * @return
   * @param query 查询 graphql 语法文档
   * @param undefined 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async currentAdministrator(
    query: DocumentNode = GraphqlImporter.currentAdministrator,
    operation?: string
  ): Promise<Response<AdministratorResponse>> {
    return commonRequestApi<AdministratorResponse>(SERVER_URL, {
      query: query,
      variables: undefined,
      operation: operation
    })
  }

  /**   * 单位是否存在集体缴费管理员
   * @param unitId
   * @return
   * @param query 查询 graphql 语法文档
   * @param unitId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async existsCollectiveAdminInUnit(
    unitId: string,
    query: DocumentNode = GraphqlImporter.existsCollectiveAdminInUnit,
    operation?: string
  ): Promise<Response<boolean>> {
    return commonRequestApi<boolean>(SERVER_URL, {
      query: query,
      variables: { unitId },
      operation: operation
    })
  }

  /**   * 通过单位id和集体缴费管理员手机号验证码token 校验集体缴费单位管理员是否存在
   * @param unitId
   * @return
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async existsCollectiveAdminWithUnitIdAndPhoneCaptchaToken(
    params: { unitId?: string; captchaToken?: string },
    query: DocumentNode = GraphqlImporter.existsCollectiveAdminWithUnitIdAndPhoneCaptchaToken,
    operation?: string
  ): Promise<Response<boolean>> {
    return commonRequestApi<boolean>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 获取施教机构管理员分页
   * @param page
   * @param param
   * @return
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findTeachAdministratorPage(
    params: { page?: Page; param?: TeachAdministratorParamRequest },
    query: DocumentNode = GraphqlImporter.findTeachAdministratorPage,
    operation?: string
  ): Promise<Response<TeachAdministratorItemResponsePage>> {
    return commonRequestApi<TeachAdministratorItemResponsePage>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 获取施教机构分页
   * @param page
   * @param param
   * @return
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findTeachUnitPage(
    params: { page?: Page; param?: TeachUnitParamDTO },
    query: DocumentNode = GraphqlImporter.findTeachUnitPage,
    operation?: string
  ): Promise<Response<TeachUnitItemResponsePage>> {
    return commonRequestApi<TeachUnitItemResponsePage>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 获取管理员详情
   * @param userId 管理员id
   * @return
   * @param query 查询 graphql 语法文档
   * @param userId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getAdministrator(
    userId: string,
    query: DocumentNode = GraphqlImporter.getAdministrator,
    operation?: string
  ): Promise<Response<AdministratorResponse>> {
    return commonRequestApi<AdministratorResponse>(SERVER_URL, {
      query: query,
      variables: { userId },
      operation: operation
    })
  }

  /**   * 获取管理员分页
   * @param page
   * @param param
   * @return
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getAdministratorPage(
    params: { page?: Page; param?: AdministratorParamRequest },
    query: DocumentNode = GraphqlImporter.getAdministratorPage,
    operation?: string
  ): Promise<Response<AdministratorPageResponsePage>> {
    return commonRequestApi<AdministratorPageResponsePage>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 分页获取集体缴费管理员
   * @param page
   * @param query
   * @return
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getCollectiveAdminPage(
    params: { page?: Page; query?: CollectiveAdminQueryRequest },
    query: DocumentNode = GraphqlImporter.getCollectiveAdminPage,
    operation?: string
  ): Promise<Response<CollectiveAdminItemResponsePage>> {
    return commonRequestApi<CollectiveAdminItemResponsePage>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 获取集体缴费管理员
   * @param userId
   * @return
   * @param query 查询 graphql 语法文档
   * @param userId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getCollectiveAdministrator(
    userId: string,
    query: DocumentNode = GraphqlImporter.getCollectiveAdministrator,
    operation?: string
  ): Promise<Response<CollectiveAdministratorResponse>> {
    return commonRequestApi<CollectiveAdministratorResponse>(SERVER_URL, {
      query: query,
      variables: { userId },
      operation: operation
    })
  }

  /**   * 获取集体缴费单位分页
   * @param page
   * @param query
   * @return
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getCollectiveUnitPage(
    params: { page?: Page; query?: CollectiveUnitQueryRequest },
    query: DocumentNode = GraphqlImporter.getCollectiveUnitPage,
    operation?: string
  ): Promise<Response<CollectiveUnitItemResponsePage>> {
    return commonRequestApi<CollectiveUnitItemResponsePage>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 获取钉钉部门信息
   * @param deptId
   * @return
   * @param query 查询 graphql 语法文档
   * @param deptId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getDingTalkDepartment(
    deptId: string,
    query: DocumentNode = GraphqlImporter.getDingTalkDepartment,
    operation?: string
  ): Promise<Response<DingTalkDepartmentResponse>> {
    return commonRequestApi<DingTalkDepartmentResponse>(SERVER_URL, {
      query: query,
      variables: { deptId },
      operation: operation
    })
  }

  /**   * 获取钉钉部门分页
   * @param page
   * @return
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getDingTalkDepartmentPage(
    params: { page?: Page; request?: DingTalkDepartmentQueryRequest },
    query: DocumentNode = GraphqlImporter.getDingTalkDepartmentPage,
    operation?: string
  ): Promise<Response<DingTalkDepartmentResponsePage>> {
    return commonRequestApi<DingTalkDepartmentResponsePage>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 根据省市区id获取地区信息
   * @param provinceId
   * @param cityId
   * @param countyId
   * @return
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getRegion(
    params: { provinceId?: string; cityId?: string; countyId?: string },
    query: DocumentNode = GraphqlImporter.getRegion,
    operation?: string
  ): Promise<Response<RegionResponse>> {
    return commonRequestApi<RegionResponse>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 获取资源供应商管理员
   * @param userId
   * @param query 查询 graphql 语法文档
   * @param userId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getResourceVendorsAdmin(
    userId: string,
    query: DocumentNode = GraphqlImporter.getResourceVendorsAdmin,
    operation?: string
  ): Promise<Response<ResourceVendorsAdminResponse>> {
    return commonRequestApi<ResourceVendorsAdminResponse>(SERVER_URL, {
      query: query,
      variables: { userId },
      operation: operation
    })
  }

  /**   * 获取资源供应商信息
   * @param unitId
   * @return
   * @param query 查询 graphql 语法文档
   * @param unitId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getResourceVendorsUnit(
    unitId: string,
    query: DocumentNode = GraphqlImporter.getResourceVendorsUnit,
    operation?: string
  ): Promise<Response<ResourceVendorsUnitResponse>> {
    return commonRequestApi<ResourceVendorsUnitResponse>(SERVER_URL, {
      query: query,
      variables: { unitId },
      operation: operation
    })
  }

  /**   * 根据用户类型和登录账号获取用户角色信息
   * @param userType 用户类型  1: 客户域; 2: 管理域; 3: 运维域;
   * @param loginType
   * @param loginInput
   * @return
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getRolesByLoginInput(
    params: { userType: number; loginType?: LoginType; loginInput?: string },
    query: DocumentNode = GraphqlImporter.getRolesByLoginInput,
    operation?: string
  ): Promise<Response<Array<RoleResponse>>> {
    return commonRequestApi<Array<RoleResponse>>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 获取学员信息
   * @param
   * @return
   * @param query 查询 graphql 语法文档
   * @param id 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getStudent(
    id: string,
    query: DocumentNode = GraphqlImporter.getStudent,
    operation?: string
  ): Promise<Response<StudentResponse>> {
    return commonRequestApi<StudentResponse>(SERVER_URL, {
      query: query,
      variables: { id },
      operation: operation
    })
  }

  /**   * 根据父级地区id获取子级地区
   * @param parentId
   * @return
   * @param query 查询 graphql 语法文档
   * @param parentId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getSubRegionListByParentId(
    parentId: string,
    query: DocumentNode = GraphqlImporter.getSubRegionListByParentId,
    operation?: string
  ): Promise<Response<Array<BaseRegionResponse>>> {
    return commonRequestApi<Array<BaseRegionResponse>>(SERVER_URL, {
      query: query,
      variables: { parentId },
      operation: operation
    })
  }

  /**   * 获取施教机构管理员
   * @param id
   * @return
   * @param query 查询 graphql 语法文档
   * @param id 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getTeachAdministrator(
    id: string,
    query: DocumentNode = GraphqlImporter.getTeachAdministrator,
    operation?: string
  ): Promise<Response<TeachAdministratorResponse>> {
    return commonRequestApi<TeachAdministratorResponse>(SERVER_URL, {
      query: query,
      variables: { id },
      operation: operation
    })
  }

  /**   * 获取施教机构
   * @param unitId
   * @return
   * @param query 查询 graphql 语法文档
   * @param unitId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getTeachUnit(
    unitId: string,
    query: DocumentNode = GraphqlImporter.getTeachUnit,
    operation?: string
  ): Promise<Response<TeachUnitResponse>> {
    return commonRequestApi<TeachUnitResponse>(SERVER_URL, {
      query: query,
      variables: { unitId },
      operation: operation
    })
  }

  /**   * 获取单位详情
   * @param unitId
   * @return
   * @param query 查询 graphql 语法文档
   * @param unitId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getUnitInfo(
    unitId: string,
    query: DocumentNode = GraphqlImporter.getUnitInfo,
    operation?: string
  ): Promise<Response<UnitResponse>> {
    return commonRequestApi<UnitResponse>(SERVER_URL, {
      query: query,
      variables: { unitId },
      operation: operation
    })
  }

  /**   * 根据登陆账号和密码获取用户id
   * @param userType
   * @param loginInput
   * @param password
   * @return
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getUserIdByLoginAccount(
    params: { userType: number; loginInput?: string; password?: string },
    query: DocumentNode = GraphqlImporter.getUserIdByLoginAccount,
    operation?: string
  ): Promise<Response<CommonUserInfoResponse>> {
    return commonRequestApi<CommonUserInfoResponse>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 是否绑定微信第三方账号
   * @param openId
   * @param unionId
   * @param connectType 41：微信登录，42：微信公众号，43：微信小程序
   * @param wxNickname 微信昵称，若其他类型已绑定将使用这个微信昵称自动绑定，为空则使用用户昵称
   * @return
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async haveBindWXByOpenIdAndUnionIdForOpenAPI(
    params: { openId?: string; unionId?: string; connectType: number; wxNickname?: string },
    query: DocumentNode = GraphqlImporter.haveBindWXByOpenIdAndUnionIdForOpenAPI,
    operation?: string
  ): Promise<Response<boolean>> {
    return commonRequestApi<boolean>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 是否绑定微信登录
   * @param token
   * @return
   * @param query 查询 graphql 语法文档
   * @param token 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async haveBindWXByTokenForOpenAPI(
    token: string,
    query: DocumentNode = GraphqlImporter.haveBindWXByTokenForOpenAPI,
    operation?: string
  ): Promise<Response<boolean>> {
    return commonRequestApi<boolean>(SERVER_URL, {
      query: query,
      variables: { token },
      operation: operation
    })
  }

  /**   * 手机号是否已被学员使用
   * @param phoneNumber
   * @return
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async isPhoneNumberExistsInStudent(
    params: { phoneNumber?: string; exceptUserId?: string },
    query: DocumentNode = GraphqlImporter.isPhoneNumberExistsInStudent,
    operation?: string
  ): Promise<Response<boolean>> {
    return commonRequestApi<boolean>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 根据关键字查询第三方企业信息列表
   * @param keyword
   * @return
   * @param query 查询 graphql 语法文档
   * @param keyword 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async listThirdIndustryCommerceByKeyword(
    keyword: string,
    query: DocumentNode = GraphqlImporter.listThirdIndustryCommerceByKeyword,
    operation?: string
  ): Promise<Response<Array<ThirdIndustryCommerceInfoResponse>>> {
    return commonRequestApi<Array<ThirdIndustryCommerceInfoResponse>>(SERVER_URL, {
      query: query,
      variables: { keyword },
      operation: operation
    })
  }

  /**   * 获取名称相关（模糊匹配）的用人单位名称
   * @param name
   * @return
   * @param query 查询 graphql 语法文档
   * @param name 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async listTop10RelateUnitName(
    name: string,
    query: DocumentNode = GraphqlImporter.listTop10RelateUnitName,
    operation?: string
  ): Promise<Response<Array<string>>> {
    return commonRequestApi<Array<string>>(SERVER_URL, {
      query: query,
      variables: { name },
      operation: operation
    })
  }

  /**   * 账号是否已存在
   * @param loginType
   * @param loginInput
   * @return
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async loginInputExists(
    params: { loginType?: LoginType; loginInput?: string; exceptUserId?: string },
    query: DocumentNode = GraphqlImporter.loginInputExists,
    operation?: string
  ): Promise<Response<boolean>> {
    return commonRequestApi<boolean>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 获取用人单位分页
   * @param page
   * @param query
   * @return
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async pageUnit(
    params: { page?: Page; query?: UnitQueryRequest },
    query: DocumentNode = GraphqlImporter.pageUnit,
    operation?: string
  ): Promise<Response<UnitItemResponsePage>> {
    return commonRequestApi<UnitItemResponsePage>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 使用唯一性值+用户名 查询用户是否存在
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async userExistsWithUniqueDataAndName(
    params: { uniqueData?: string; name?: string },
    query: DocumentNode = GraphqlImporter.userExistsWithUniqueDataAndName,
    operation?: string
  ): Promise<Response<boolean>> {
    return commonRequestApi<boolean>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 账号是否可用
   * @param loginInput
   * @param exceptUserId
   * @return
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async validateLoginInput(
    params: { loginInput?: string; exceptUserId?: string },
    query: DocumentNode = GraphqlImporter.validateLoginInput,
    operation?: string
  ): Promise<Response<boolean>> {
    return commonRequestApi<boolean>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 添加用户角色信息
   * @param userId 用户id
   * @param roleIds 角色id
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async addUserOwnRoles(
    params: { userId: string; roleIds: Array<string> },
    mutate: DocumentNode = GraphqlImporter.addUserOwnRoles,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 使用登陆账号和token绑定微信登录
   * @deprecated 有风险，只传登录账号不够安全
   * @param token
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async bindWXByTokenAndLoginInputForOpenAPI(
    params: { loginInput?: string; token?: string },
    mutate: DocumentNode = GraphqlImporter.bindWXByTokenAndLoginInputForOpenAPI,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 绑定微信登录
   * @param token
   * @param mutate 查询 graphql 语法文档
   * @param token 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async bindWXByTokenForOpenAPI(
    token: string,
    mutate: DocumentNode = GraphqlImporter.bindWXByTokenForOpenAPI,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { token },
      operation: operation
    })
  }

  /**   * 使用登陆账号、密码和token绑定微信登录
   * @deprecated 有风险，只传登录账号不够安全
   * @param token
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async bindWXForOpenAPI(
    params: { loginInput?: string; password?: string; token?: string },
    mutate: DocumentNode = GraphqlImporter.bindWXForOpenAPI,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 使用登陆账号、openId和unionId绑定微信小程序
   * @deprecated 有风险，只传登录账号不够安全
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async bindWXMiniProgramByOpenIdAndUnionIdLoginInputForOpenAPI(
    params: { loginInput?: string; openId?: string; unionId?: string; wxNickname?: string },
    mutate: DocumentNode = GraphqlImporter.bindWXMiniProgramByOpenIdAndUnionIdLoginInputForOpenAPI,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 使用登陆账号、密码\openId和unionId绑定微信小程序
   * @deprecated 有风险，只传登录账号不够安全
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async bindWXMiniProgramForOpenAPI(
    params: { loginInput?: string; password?: string; openId?: string; unionId?: string; wxNickname?: string },
    mutate: DocumentNode = GraphqlImporter.bindWXMiniProgramForOpenAPI,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 使用登陆账号、openId和unionId绑定微信公众号
   * @deprecated 有风险，只传登录账号不够安全
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async bindWXOfficialAccountByOpenIdAndUnionIdLoginInputForOpenAPI(
    params: { loginInput?: string; openId?: string; unionId?: string; wxNickname?: string },
    mutate: DocumentNode = GraphqlImporter.bindWXOfficialAccountByOpenIdAndUnionIdLoginInputForOpenAPI,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 使用登陆账号、密码\openId和unionId绑定微信公众号
   * @deprecated 有风险，只传登录账号不够安全
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async bindWXOfficialAccountForOpenAPI(
    params: { loginInput?: string; password?: string; openId?: string; unionId?: string; wxNickname?: string },
    mutate: DocumentNode = GraphqlImporter.bindWXOfficialAccountForOpenAPI,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 修改密码
   * @param oldPassword
   * @param newPassword
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async changePassword(
    params: { oldPassword?: string; newPassword?: string },
    mutate: DocumentNode = GraphqlImporter.changePassword,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 创建管理员
   * @param createInfo
   * @return
   * @param mutate 查询 graphql 语法文档
   * @param createInfo 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async createAdministrator(
    createInfo: AdministratorCreateRequest,
    mutate: DocumentNode = GraphqlImporter.createAdministrator,
    operation?: string
  ): Promise<Response<AdministratorResponse>> {
    return commonRequestApi<AdministratorResponse>(SERVER_URL, {
      query: mutate,
      variables: { createInfo },
      operation: operation
    })
  }

  /**   * 创建资源供应商管理员
   * @param request
   * @param mutate 查询 graphql 语法文档
   * @param request 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async createResourceVendorsAdmin(
    request: ResourceVendorsAdminCreateRequest,
    mutate: DocumentNode = GraphqlImporter.createResourceVendorsAdmin,
    operation?: string
  ): Promise<Response<ResourceVendorsAdminResponse>> {
    return commonRequestApi<ResourceVendorsAdminResponse>(SERVER_URL, {
      query: mutate,
      variables: { request },
      operation: operation
    })
  }

  /**   * 创建资源供应商，同步创建一个管理员
   * @param request
   * @param mutate 查询 graphql 语法文档
   * @param request 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async createResourceVendorsUnitWithAdmin(
    request: ResourceVendorsUnitAndAdminCreateRequest,
    mutate: DocumentNode = GraphqlImporter.createResourceVendorsUnitWithAdmin,
    operation?: string
  ): Promise<Response<ResourceVendorsCreateWithAdminResultResponse>> {
    return commonRequestApi<ResourceVendorsCreateWithAdminResultResponse>(SERVER_URL, {
      query: mutate,
      variables: { request },
      operation: operation
    })
  }

  /**   * 创建学员
   * @param create
   * @return
   * @param mutate 查询 graphql 语法文档
   * @param create 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async createStudent(
    create: StudentCreateRequest,
    mutate: DocumentNode = GraphqlImporter.createStudent,
    operation?: string
  ): Promise<Response<StudentResponse>> {
    return commonRequestApi<StudentResponse>(SERVER_URL, {
      query: mutate,
      variables: { create },
      operation: operation
    })
  }

  /**   * 使用短信验证码token创建学员并自动绑定账号
   * @param createWithPhoneCaptcha
   * @return
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async createStudentAndBindWXWithPhoneCaptchaToken(
    params: { captchaToken?: string; createWithPhoneCaptcha?: StudentCreateWithPhoneCaptchaAndTokenRequest },
    mutate: DocumentNode = GraphqlImporter.createStudentAndBindWXWithPhoneCaptchaToken,
    operation?: string
  ): Promise<Response<StudentResponse>> {
    return commonRequestApi<StudentResponse>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 使用短信验证码token创建学员
   * @param createWithPhoneCaptcha
   * @return
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async createStudentWithPhoneCaptchaToken(
    params: { captchaToken?: string; createWithPhoneCaptcha?: StudentCreateWithPhoneCaptchaRequest },
    mutate: DocumentNode = GraphqlImporter.createStudentWithPhoneCaptchaToken,
    operation?: string
  ): Promise<Response<StudentResponse>> {
    return commonRequestApi<StudentResponse>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 创建施教机构管理员
   * @param create
   * @return
   * @param mutate 查询 graphql 语法文档
   * @param create 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async createTeachAdministrator(
    create: TeachAdministratorCreateRequest,
    mutate: DocumentNode = GraphqlImporter.createTeachAdministrator,
    operation?: string
  ): Promise<Response<TeachAdministratorResponse>> {
    return commonRequestApi<TeachAdministratorResponse>(SERVER_URL, {
      query: mutate,
      variables: { create },
      operation: operation
    })
  }

  /**   * 创建施教机构
   * @param create
   * @return
   * @param mutate 查询 graphql 语法文档
   * @param create 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async createTeachUnit(
    create: TeachUnitCreateRequest,
    mutate: DocumentNode = GraphqlImporter.createTeachUnit,
    operation?: string
  ): Promise<Response<TeachUnitResponse>> {
    return commonRequestApi<TeachUnitResponse>(SERVER_URL, {
      query: mutate,
      variables: { create },
      operation: operation
    })
  }

  /**   * 使用第三方企业工商信息创建用人单位
   * @param openId
   * @param mutate 查询 graphql 语法文档
   * @param openId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async createUnitWithThirdIndustryCommerceInfo(
    openId: string,
    mutate: DocumentNode = GraphqlImporter.createUnitWithThirdIndustryCommerceInfo,
    operation?: string
  ): Promise<Response<UnitResponse>> {
    return commonRequestApi<UnitResponse>(SERVER_URL, {
      query: mutate,
      variables: { openId },
      operation: operation
    })
  }

  /**   * 停用管理员
   * @param userId
   * @param mutate 查询 graphql 语法文档
   * @param userId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async disableAdministrator(
    userId: string,
    mutate: DocumentNode = GraphqlImporter.disableAdministrator,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { userId },
      operation: operation
    })
  }

  /**   * 停用集体缴费单位
   * @param unitId
   * @param mutate 查询 graphql 语法文档
   * @param unitId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async disableCollectiveUnit(
    unitId: string,
    mutate: DocumentNode = GraphqlImporter.disableCollectiveUnit,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { unitId },
      operation: operation
    })
  }

  /**   * 停用施教机构管理员
   * @param administratorId
   * @param mutate 查询 graphql 语法文档
   * @param administratorId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async disableTeachAdministrator(
    administratorId: string,
    mutate: DocumentNode = GraphqlImporter.disableTeachAdministrator,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { administratorId },
      operation: operation
    })
  }

  /**   * 停用施教机构
   * @param unitId
   * @param mutate 查询 graphql 语法文档
   * @param unitId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async disableTeachUnit(
    unitId: string,
    mutate: DocumentNode = GraphqlImporter.disableTeachUnit,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { unitId },
      operation: operation
    })
  }

  /**   * 启用管理员
   * @param userId
   * @param mutate 查询 graphql 语法文档
   * @param userId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async enableAdministrator(
    userId: string,
    mutate: DocumentNode = GraphqlImporter.enableAdministrator,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { userId },
      operation: operation
    })
  }

  /**   * 启用集体缴费单位
   * @param unitId
   * @param mutate 查询 graphql 语法文档
   * @param unitId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async enableCollectiveUnit(
    unitId: string,
    mutate: DocumentNode = GraphqlImporter.enableCollectiveUnit,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { unitId },
      operation: operation
    })
  }

  /**   * 启用资源供应商管理员
   * @param userId
   * @param mutate 查询 graphql 语法文档
   * @param userId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async enableResourceVendorsAdmin(
    userId: string,
    mutate: DocumentNode = GraphqlImporter.enableResourceVendorsAdmin,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { userId },
      operation: operation
    })
  }

  /**   * 启用资源供应商
   * @param unitId
   * @param mutate 查询 graphql 语法文档
   * @param unitId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async enableResourceVendorsUnit(
    unitId: string,
    mutate: DocumentNode = GraphqlImporter.enableResourceVendorsUnit,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { unitId },
      operation: operation
    })
  }

  /**   * 启用施教机构管理员
   * @param administratorId
   * @param mutate 查询 graphql 语法文档
   * @param administratorId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async enableTeachAdministrator(
    administratorId: string,
    mutate: DocumentNode = GraphqlImporter.enableTeachAdministrator,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { administratorId },
      operation: operation
    })
  }

  /**   * 启用施教机构
   * @param unitId
   * @param mutate 查询 graphql 语法文档
   * @param unitId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async enableTeachUnit(
    unitId: string,
    mutate: DocumentNode = GraphqlImporter.enableTeachUnit,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { unitId },
      operation: operation
    })
  }

  /**   * 注册集体缴费管理员
   * @return
   * @param mutate 查询 graphql 语法文档
   * @param create 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async registerCollectionAdministrator(
    create: CollectiveAdministratorCreateRequest,
    mutate: DocumentNode = GraphqlImporter.registerCollectionAdministrator,
    operation?: string
  ): Promise<Response<CollectiveAdministratorResponse>> {
    return commonRequestApi<CollectiveAdministratorResponse>(SERVER_URL, {
      query: mutate,
      variables: { create },
      operation: operation
    })
  }

  /**   * 使用手机验证码注册集体缴费管理员
   * @return
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async registerCollectionAdministratorWithPhoneCaptchaToken(
    params: { captchaToken?: string; create?: CollectiveAdministratorCreateRequest },
    mutate: DocumentNode = GraphqlImporter.registerCollectionAdministratorWithPhoneCaptchaToken,
    operation?: string
  ): Promise<Response<CollectiveAdministratorResponse>> {
    return commonRequestApi<CollectiveAdministratorResponse>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 移除用户角色信息
   * @param userId
   * @param roleIds
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async removeUserOwnRoles(
    params: { userId: string; roleIds: Array<string> },
    mutate: DocumentNode = GraphqlImporter.removeUserOwnRoles,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 替换用户登陆账号
   * @param userId
   * @param loginAccounts
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async replaceAdministratorLoginAccountant(
    params: { userId?: string; loginAccounts?: Array<LoginAccountUpdateRequest> },
    mutate: DocumentNode = GraphqlImporter.replaceAdministratorLoginAccountant,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 重置用户的所有登录账号的密码
   * @param userId
   * @param newPassword
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async resetAdministratorPassword(
    params: { userId?: string; newPassword?: string },
    mutate: DocumentNode = GraphqlImporter.resetAdministratorPassword,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 使用手机号的验证码token 重置密码
   * @param newPassword
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async resetCustomerPasswordWithPhoneCaptchaToken(
    params: { captchaToken?: string; newPassword?: string },
    mutate: DocumentNode = GraphqlImporter.resetCustomerPasswordWithPhoneCaptchaToken,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 重置密码
   * @param newPassword
   * @param mutate 查询 graphql 语法文档
   * @param newPassword 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async resetPassword(
    newPassword: string,
    mutate: DocumentNode = GraphqlImporter.resetPassword,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { newPassword },
      operation: operation
    })
  }

  /**   * 使用手机号的验证码token 重置密码
   * @param newPassword
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async resetPasswordWithPhoneCaptchaToken(
    params: { captchaToken?: string; newPassword?: string },
    mutate: DocumentNode = GraphqlImporter.resetPasswordWithPhoneCaptchaToken,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 使用唯一性值+用户名 重置密码
   * @param newPassword
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async resetPasswordWithUniqueDataAndName(
    params: { uniqueData?: string; name?: string; newPassword?: string },
    mutate: DocumentNode = GraphqlImporter.resetPasswordWithUniqueDataAndName,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 重置资源供应商管理员密码
   * @param userId
   * @param newPassword
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async resetResourceVendorsAdminPassword(
    params: { userId?: string; newPassword?: string },
    mutate: DocumentNode = GraphqlImporter.resetResourceVendorsAdminPassword,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 重置施教机构管理员密码
   * @param userId
   * @param newPassword
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async resetTeachAdminPassword(
    params: { userId?: string; newPassword?: string },
    mutate: DocumentNode = GraphqlImporter.resetTeachAdminPassword,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 重置用户角色信息
   * @param userId
   * @param roleIds
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async resetUserOwnRoles(
    params: { userId: string; roleIds: Array<string> },
    mutate: DocumentNode = GraphqlImporter.resetUserOwnRoles,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 停用资源供应商管理员
   * @param userId
   * @param mutate 查询 graphql 语法文档
   * @param userId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async suspendResourceVendorsAdmin(
    userId: string,
    mutate: DocumentNode = GraphqlImporter.suspendResourceVendorsAdmin,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { userId },
      operation: operation
    })
  }

  /**   * 停用资源供应商
   * @param unitId
   * @param mutate 查询 graphql 语法文档
   * @param unitId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async suspendResourceVendorsUnit(
    unitId: string,
    mutate: DocumentNode = GraphqlImporter.suspendResourceVendorsUnit,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { unitId },
      operation: operation
    })
  }

  /**   * 同步企业信息到本地持久化
   * @param openId 开放平台内的企业id
   * @param enforce 是否强制同步（否的话企业信息已存在不会再次同步）
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async synchronize(
    params: { openId?: string; enforce: boolean },
    mutate: DocumentNode = GraphqlImporter.synchronize,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 解绑微信
   * @param userId 不传默认解绑自己的微信
   * @param mutate 查询 graphql 语法文档
   * @param userId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async unBindWX(
    userId: string,
    mutate: DocumentNode = GraphqlImporter.unBindWX,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { userId },
      operation: operation
    })
  }

  /**   * 修改管理员
   * @param updateInfo
   * @param mutate 查询 graphql 语法文档
   * @param updateInfo 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async updateAdministrator(
    updateInfo: AdministratorUpdateRequest,
    mutate: DocumentNode = GraphqlImporter.updateAdministrator,
    operation?: string
  ): Promise<Response<AdministratorResponse>> {
    return commonRequestApi<AdministratorResponse>(SERVER_URL, {
      query: mutate,
      variables: { updateInfo },
      operation: operation
    })
  }

  /**   * 使用修改集体缴费管理员信息
   * @return
   * @param mutate 查询 graphql 语法文档
   * @param update 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async updateCollectionAdministrator(
    update: CollectiveAdministratorUpdateRequest,
    mutate: DocumentNode = GraphqlImporter.updateCollectionAdministrator,
    operation?: string
  ): Promise<Response<CollectiveAdministratorResponse>> {
    return commonRequestApi<CollectiveAdministratorResponse>(SERVER_URL, {
      query: mutate,
      variables: { update },
      operation: operation
    })
  }

  /**   * 修改集体缴费单位
   * @param request
   * @return
   * @param mutate 查询 graphql 语法文档
   * @param request 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async updateCollectiveUnit(
    request: CollectiveUnitUpdateRequest,
    mutate: DocumentNode = GraphqlImporter.updateCollectiveUnit,
    operation?: string
  ): Promise<Response<CollectiveUnitResponse>> {
    return commonRequestApi<CollectiveUnitResponse>(SERVER_URL, {
      query: mutate,
      variables: { request },
      operation: operation
    })
  }

  /**   * 使用手机验证码token修改集体缴费管理员手机号
   * @return
   * @param mutate 查询 graphql 语法文档
   * @param captchaToken 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async updateCurrentCollectionAdministratorPhoneWithPhoneCaptchaToken(
    captchaToken: string,
    mutate: DocumentNode = GraphqlImporter.updateCurrentCollectionAdministratorPhoneWithPhoneCaptchaToken,
    operation?: string
  ): Promise<Response<CollectiveAdministratorResponse>> {
    return commonRequestApi<CollectiveAdministratorResponse>(SERVER_URL, {
      query: mutate,
      variables: { captchaToken },
      operation: operation
    })
  }

  /**   * 修改资源供应商管理员
   * @param request
   * @param mutate 查询 graphql 语法文档
   * @param request 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async updateResourceVendorsAdmin(
    request: ResourceVendorsAdminUpdateRequest,
    mutate: DocumentNode = GraphqlImporter.updateResourceVendorsAdmin,
    operation?: string
  ): Promise<Response<ResourceVendorsAdminResponse>> {
    return commonRequestApi<ResourceVendorsAdminResponse>(SERVER_URL, {
      query: mutate,
      variables: { request },
      operation: operation
    })
  }

  /**   * 修改资源供应商信息
   * @param request
   * @return
   * @param mutate 查询 graphql 语法文档
   * @param request 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async updateResourceVendorsUnit(
    request: ResourceVendorsUnitUpdateRequest,
    mutate: DocumentNode = GraphqlImporter.updateResourceVendorsUnit,
    operation?: string
  ): Promise<Response<ResourceVendorsUnitResponse>> {
    return commonRequestApi<ResourceVendorsUnitResponse>(SERVER_URL, {
      query: mutate,
      variables: { request },
      operation: operation
    })
  }

  /**   * 修改学员
   * @param update
   * @return
   * @param mutate 查询 graphql 语法文档
   * @param update 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async updateStudent(
    update: StudentUpdateRequest,
    mutate: DocumentNode = GraphqlImporter.updateStudent,
    operation?: string
  ): Promise<Response<StudentResponse>> {
    return commonRequestApi<StudentResponse>(SERVER_URL, {
      query: mutate,
      variables: { update },
      operation: operation
    })
  }

  /**   * 修改施教机构管理员
   * @param update
   * @return
   * @param mutate 查询 graphql 语法文档
   * @param update 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async updateTeachAdministrator(
    update: TeachAdministratorUpdateRequest,
    mutate: DocumentNode = GraphqlImporter.updateTeachAdministrator,
    operation?: string
  ): Promise<Response<TeachAdministratorResponse>> {
    return commonRequestApi<TeachAdministratorResponse>(SERVER_URL, {
      query: mutate,
      variables: { update },
      operation: operation
    })
  }

  /**   * 修改施教机构
   * @param update
   * @return
   * @param mutate 查询 graphql 语法文档
   * @param update 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async updateTeachUnit(
    update: TeachUnitUpdateRequest,
    mutate: DocumentNode = GraphqlImporter.updateTeachUnit,
    operation?: string
  ): Promise<Response<TeachUnitResponse>> {
    return commonRequestApi<TeachUnitResponse>(SERVER_URL, {
      query: mutate,
      variables: { update },
      operation: operation
    })
  }
}

export default new DataGateway()
